
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Travelagentsinpune() {



    const cardData =
    {
        keyword: 'Travel Agents in Pune',
        heading: 'Platinum24 Cabs: Travel Agents in Pune',
        headingDescription: ' Platinum24 Cabs is among the most trusted Travel Agents in Pune, offering complete travel solutions including local cab services, outstation taxis, airport transfers, and customized tour packages. With a modern fleet of hatchbacks, sedans, SUVs, luxury cars, minibuses, and tempo travellers, we cater to families, corporate clients, and tourists alike. Our professional chauffeurs, 24/7 availability, and affordable pricing ensure a smooth travel experience across Maharashtra and beyond. Whether it’s a weekend getaway, pilgrimage yatra, business trip, or group holiday, Platinum24 Cabs acts as your reliable travel partner in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the political seat of the Maratha Empire, it showcases grand gates, fountains, and gardens. Although partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show brings history alive. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Indo-Italian architecture. It gained prominence during the freedom struggle as Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. The palace now houses a museum with Gandhi’s personal items and photos. Surrounded by sprawling gardens, it offers peace and reflection. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s inspirational historic site."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The hill fort offers trekking trails with scenic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon makes it lush with mist and waterfalls. Local villagers serve traditional pithla-bhakri at the top. Sinhagad is Pune’s blend of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The magnificent idol is adorned with gold and precious ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also renowned for charitable and cultural activities. Devotees visit throughout the year for blessings. Dagdusheth Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. The temple features huge stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it provides peace and spirituality amidst urban life. Its ancient carvings reflect early Indian craftsmanship. Evening prayers add to its mystical charm. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include sculptures, ornaments, musical instruments, and daily-life antiques. The recreated Mastani Mahal is the museum’s highlight. Students, historians, and tourists find it educational and fascinating. It preserves centuries of Indian art and traditions. The museum is Pune’s cultural treasure trove."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop Parvati Temple is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. The climb of 103 steps is both devotional and adventurous. Smaller shrines and museums surround the main temple. Sunrise and sunset views are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts visitors from all over the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and tranquil halls enhance the experience. It is ideal for peace, rejuvenation, and self-discovery. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns create a serene environment. Families enjoy peaceful strolls, picnics, and photography here. The garden represents Indo-Japanese friendship. Seasonal flowers make it colorful year-round. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city and offers picturesque views of hills and flowing waters. During monsoon, the overflowing dam is a spectacular sight. Vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



    "services": [
    {
      "name": "Travel Agents Pune",
      "description": "Professional travel agents in Pune offering end-to-end travel solutions including domestic and international flight bookings, hotel reservations, and customized tour packages. With expert advice and personalized service, they help travelers plan hassle-free trips tailored to individual preferences and budgets."
    },
    {
      "name": "Pune Tour Operators",
      "description": "Reliable tour operators based in Pune specialize in organizing group tours, adventure trips, cultural excursions, and family vacations. They provide comprehensive itineraries, local guides, and seamless logistics ensuring memorable and well-managed travel experiences."
    },
    {
      "name": "Pune Travel Agency",
      "description": "Full-service travel agencies in Pune assisting clients with flight tickets, hotel bookings, visa assistance, travel insurance, and holiday packages. These agencies prioritize customer satisfaction by offering competitive prices, trusted partnerships, and convenient booking processes."
    },
    {
      "name": "Best Travel Agents in Pune",
      "description": "Top-rated travel agents in Pune known for their professionalism, transparency, and excellent customer support. They offer exclusive deals, customized holiday planning, and expert guidance, ensuring travelers get the best value and memorable journeys."
    },
    {
      "name": "Pune Holiday Packages",
      "description": "A wide array of holiday packages curated by Pune-based agencies covering popular domestic and international destinations. These packages include transportation, accommodation, sightseeing, meals, and guided tours designed for families, solo travelers, and corporate clients."
    },
    {
      "name": "Pune Travel Consultants",
      "description": "Expert travel consultants in Pune provide personalized travel planning, itinerary creation, and booking assistance. They offer insights into destination options, travel trends, and cost-effective solutions to suit every traveler’s needs."
    },
    {
      "name": "Pune Travel Booking",
      "description": "Efficient travel booking services in Pune facilitating seamless reservations of flights, trains, buses, and hotels through online and offline channels. With easy payment options and instant confirmation, booking your next trip becomes hassle-free."
    },
    {
      "name": "Pune Tour Packages",
      "description": "Specialized tour packages designed by Pune tour operators offering adventure tours, pilgrimage trips, weekend getaways, and international tours. Packages often include transportation, sightseeing, meals, and accommodation to provide a hassle-free travel experience."
    },
    {
      "name": "Pune Travel Deals",
      "description": "Exclusive travel deals and discounts provided by Pune travel agents on flights, hotels, holiday packages, and cruises. These deals are frequently updated and tailored to meet seasonal travel demands and budget preferences."
    },
    {
      "name": "Pune Travel Services",
      "description": "Comprehensive travel services in Pune covering ticketing, visa assistance, travel insurance, airport transfers, and concierge services. These services aim to make every aspect of travel smooth and convenient for individuals and corporate clients."
    },
    {
      "name": "Corporate Travel Agents Pune",
      "description": "Corporate travel agents in Pune specialize in managing business travel logistics including flight bookings, hotel accommodations, event travel, and expense management. They offer tailored corporate travel policies and round-the-clock support to optimize business travel efficiency."
    },
    {
      "name": "Pune Ticket Booking Agents",
      "description": "Trusted ticket booking agents in Pune facilitating reservations for domestic and international flights, trains, buses, and cruises. They provide competitive pricing, instant ticket confirmation, and customer support for smooth travel planning."
    },
    {
      "name": "Pune Travel Planning",
      "description": "Professional travel planners in Pune help you design custom itineraries, manage bookings, and coordinate travel logistics. Their expertise ensures you enjoy well-organized trips with optimal routes, activities, and accommodations."
    },
    {
      "name": "Pune Visa Consultants",
      "description": "Experienced visa consultants in Pune assist travelers with visa application processes for various countries. They offer guidance on documentation, interview preparation, and timely submission to ensure hassle-free visa approvals."
    },
    {
      "name": "Pune Travel Agent Contact",
      "description": "Access to verified contact details of top travel agents in Pune for quick inquiries, bookings, and personalized travel assistance. Whether planning a family vacation or corporate trip, easily connect with trusted agents ready to serve your needs."
    }
  ],
  "tableData": [
    ["Travel Agents Pune", "Pune Tour Operators"],
    ["Pune Travel Agency", "Best Travel Agents in Pune"],
    ["Pune Holiday Packages", "Pune Travel Consultants"],
    ["Pune Travel Booking", "Pune Tour Packages"],
    ["Pune Travel Deals", "Pune Travel Services"],
    ["Corporate Travel Agents Pune", "Pune Ticket Booking Agents"],
    ["Pune Travel Planning", "Pune Visa Consultants"],
    ["Pune Travel Agent Contact", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Trusted Travel Agents in Pune for All Your Travel Needs",
      "WhyChoosedescription": "Platinum24 Cabs partners with reliable travel agents in Pune to offer seamless travel planning and cab bookings."
    },
    {
      "WhyChooseheading": "Expert Guidance for Customized Travel Itineraries",
      "WhyChoosedescription": "Get personalized travel packages and cab services tailored to your preferences and budget."
    },
    {
      "WhyChooseheading": "Wide Network for Domestic and International Travel",
      "WhyChoosedescription": "Our travel agents have extensive connections to provide the best deals and services worldwide."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking with Combined Travel and Cab Services",
      "WhyChoosedescription": "Book flights, hotels, and cabs all in one place for a convenient travel experience."
    },
    {
      "WhyChooseheading": "Competitive Pricing and Exclusive Offers",
      "WhyChoosedescription": "Enjoy special discounts and transparent pricing through our trusted travel partners."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Travel Assistance",
      "WhyChoosedescription": "Our support team is always available to help you with bookings, changes, and queries."
    },
    {
      "WhyChooseheading": "Reliable Transportation with Platinum24 Cabs",
      "WhyChoosedescription": "Ensure smooth and comfortable travel with our trusted cab services linked through travel agents."
    },
    {
      "WhyChooseheading": "Flexible Packages for Business and Leisure Travelers",
      "WhyChoosedescription": "Choose from tailored packages designed for corporate trips, vacations, and group tours."
    }
  ]




























    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs collaborate with travel agents in Pune?',
        answer: 'Yes, Platinum24 Cabs partners with travel agents in Pune to provide seamless cab services for their clients.',
    },
    {
        question: 'How can travel agents in Pune book cabs with Platinum24 Cabs?',
        answer: 'Travel agents can book cabs for their clients through our dedicated partner portal, website, or by contacting our support team.',
    },
    {
        question: 'What types of vehicles can travel agents book for clients in Pune?',
        answer: 'Travel agents can book a range of vehicles including sedans, SUVs, tempo travellers, and premium cars based on client needs.',
    },
    {
        question: 'Are there special rates for travel agents partnering with Platinum24 Cabs?',
        answer: 'Yes, we offer competitive and customized pricing packages for travel agents to help them serve their clients better.',
    },
    {
        question: 'Can travel agents book cabs for local and outstation trips in Pune?',
        answer: 'Absolutely! We provide cab services for both local travel within Pune and outstation trips across Maharashtra and beyond.',
    },
    {
        question: 'Does Platinum24 Cabs offer support for travel agents in Pune?',
        answer: 'Yes, travel agents receive priority customer support and assistance for smooth booking and travel management.',
    },
    {
        question: 'Are corporate travel agents supported by Platinum24 Cabs in Pune?',
        answer: 'Yes, we cater to corporate travel agents with flexible billing, priority services, and customized travel solutions.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohan Patil',
        feedback: 'Partnering with Platinum24 Cabs has made booking cabs for my clients effortless and reliable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Shah',
        feedback: 'The support and service provided by Platinum24 Cabs to travel agents is excellent. Highly recommended!',
        rating: 5,
    },
];









































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];





const travelAgentsPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Platinum24 Cabs - Travel Agents in Pune",
  "image": "https://www.platinum24cab.com/assets/images/travel-agents-pune.jpg",
  "description": "Trusted travel agents in Pune offering holiday packages, ticket booking, visa consultation, and customized travel plans. Corporate and personal travel solutions by Platinum24 Cabs.",
  "url": "https://www.platinum24cab.com/travel-agents-pune",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/travel-agents-pune"
  }
};








    return (
        <div>

<Helmet>
  <title>Travel Agents in Pune | Tours, Holiday Packages & Visa Help | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Trusted travel agents in Pune offering holiday packages, ticket booking, visa consultation, and customized travel plans. Corporate and personal travel solutions by Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Travel Agents Pune, Pune Tour Operators, Pune Travel Agency, Best Travel Agents in Pune, Pune Holiday Packages, Pune Travel Consultants, Pune Travel Booking, Pune Tour Packages, Pune Travel Deals, Pune Travel Services, Corporate Travel Agents Pune, Pune Ticket Booking Agents, Pune Travel Planning, Pune Visa Consultants, Pune Travel Agent Contact"
  />
  <script type="application/ld+json">
    {JSON.stringify(travelAgentsPuneSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/31.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Travelagentsinpune;